import React from "react";
import FormRow from "../FormRow";
import { useTranslation } from 'react-i18next';
import PlaceAndAddress from "./PlaceAndAddress";

const AddressFields = ({type, formprops}) => {
  const { t } = useTranslation();
  
  return (
    <fieldset>
      <h3>
        {t(`checkout.information.${type}Address`)}
      </h3>
      <PlaceAndAddress type={type} formprops={formprops}/>
      <FormRow
        label={t('checkout.information.fullName')}
        name="fullName"
        id="fullName"
        type="text"
        data-cy="fullName"
        autoComplete="name"
        formprops={formprops}
      />
      <FormRow
        label={t('checkout.information.phoneNumber')}
        name="phoneNumber"
        id="phoneNumber"
        type="tel"
        data-cy="phoneNumber"
        autoComplete="phone"
        minlength="10"
        formprops={formprops}
      />
    </fieldset>
      
  );
};

export default AddressFields;